<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="portlet light">
                    <div class="portlet-body">
                        <div class="portlet-title">
                            <div class="caption font-red-sunglo">
                                <h2>Inviter des utilisateurs</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="portlet light">
                                    <div class="portlet-title">
                                        <div class="caption font-red-sunglo">
                                            <strong>Adhérent(s) actuellement enregistré(s)</strong>
                                        </div>
                                    </div>
                                    <div class="portlet-body">
                                        <div class="table-scrollable">
                                            <table class="table table-striped table-bordered table-advance table-hover ">
                                                <thead>
                                                    <tr>
                                                        <th><i class="fa fa-user"></i> Email </th>
                                                        <th><i class="fa fa-key"></i> Clef </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for='key in ActiveKeys'>
                                                        <th>{{key.email}}</th>
                                                        <th>{{key.key}} <button type="button" class="btn btn-outline btn-circle btn-sm red pull-right" @click='revokeAccess(key)'>Bloquer l'acces</button></th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="portlet light">
                                    <div class="portlet-title">
                                        <div class="caption font-red-sunglo">
                                            <strong>Création des clefs d'accès + Suivi des enregistrements en cours</strong>
                                        </div>
                                    </div>
                                    <div class="portlet-body">
                                        <div class="table-scrollable">
                                            <table class="table table-striped table-bordered table-advance table-hover">
                                                <thead>
                                                    <tr>
                                                        <th><i class="fa fa-user"></i> Email </th>
                                                        <th><i class="fa fa-key"></i> Clef </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th><input v-model='email' class="form-control form-control-solid placeholder-no-fix" placeholder="email" name="email" />

                                                        </th>
                                                        <th>
                                                            <a @click='createKey()' class="btn btn-outline btn-circle btn-sm green-jungle ">
                                                                <i class="fa fa-check-square"></i> Ajouter l'acces
                                                            </a>
                                                        </th>
                                                    </tr>
                                                    <tr v-for='key in CreatedKeys'>
                                                        <th>{{key.email}}</th>
                                                        <th>{{key.key}} <i class="fa fa-times pull-right" style="color:red" @click='removeKey(key)'></i></th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="portlet light">
                    <div class="portlet-body">
                        <div class="portlet-title">
                            <div class="caption font-red-sunglo">
                                <h2>Ambassadeur(s)</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="portlet light">
                                    <div class="portlet-title">
                                        <div class="caption font-red-sunglo">
                                            <strong>Ambassadeur(s) actuellement enregistré(s)</strong>
                                        </div>
                                    </div>
                                    <div class="portlet-body">
                                        <div class="table-scrollable">
                                            <table class="table table-striped table-bordered table-advance table-hover ">
                                                <thead>
                                                    <tr>
                                                        <th><i class="fa fa-user"></i> Email </th>
                                                        <th><i class="fa fa-key"></i> Clef </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for='key in ActiveKeys'>
                                                        <th>{{key.email}}</th>
                                                        <th>{{key.key}} <button type="button" class="btn btn-outline btn-circle btn-sm red pull-right" @click='revokeAccess(key)'>Bloquer l'acces</button></th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="portlet light">
                                    <div class="portlet-title">
                                        <div class="caption font-red-sunglo">
                                            <strong>Création des clefs d'accès + Suivi des enregistrements en cours</strong>
                                        </div>
                                    </div>
                                    <div class="portlet-body">
                                        <div class="table-scrollable">
                                            <table class="table table-striped table-bordered table-advance table-hover">
                                                <thead>
                                                    <tr>
                                                        <th><i class="fa fa-user"></i> Email </th>
                                                        <th><i class="fa fa-key"></i> Clef </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th><input v-model='email' class="form-control form-control-solid placeholder-no-fix" placeholder="email" name="email" />
                                                        </th>
                                                        <th>
                                                            <a @click='createKey()' class="btn btn-outline btn-circle btn-sm green-jungle ">
                                                                <i class="fa fa-check-square"></i> Ajouter l'acces
                                                            </a>
                                                        </th>
                                                    </tr>
                                                    <tr v-for='key in CreatedKeys'>
                                                        <th>{{key.email}}</th>
                                                        <th>{{key.key}} <i class="fa fa-times pull-right" style="color:red" @click='removeKey(key)'></i></th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="portlet light">
                    <div class="portlet-title">
                        <div class="caption font-red-sunglo">
                            <strong>Adhérent(s) ponctuellement bloqué(s)</strong>
                        </div>
                    </div>
                    <div class="portlet-body">
                        <div class="table-scrollable">
                            <table class="table table-striped table-bordered table-advance table-hover">
                                <thead>
                                    <tr>
                                        <th>
                                            <i class="fa fa-user"></i> Nom
                                        </th>
                                        <th>email</th>
                                        <th>Accès</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="key in BlockedKeys">
                                        <th>{{key.name}}</th>
                                        <th>{{key.email}}</th>
                                        <th>
                                            <a href="#" class="btn btn-outline btn-circle btn-sm red pull-right" @click="deleteAccess(key)"><i class="fa fa-check-square"></i> Supprimer l'accès</a>
                                            <a href="#" class="btn btn-outline btn-circle btn-sm green-jungle pull-right" @click="grantAccess(key)"><i class="fa fa-check-square"></i> Redonner l'acces</a></th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      ActiveKeys: [],
      CreatedKeys: [],
      BlockedKeys: [],
      LastKey: "",
      Admins: {},
      email: ""
    };
  },
  created() {
    this.getAdmins();
    this.getActivateKeys();
    this.getCreatedKeys();
    this.getBlockedKeys();
  },
  methods: {
    getActivateKeys() {
      var self = this;
      this.$http.get("/keys/active").then(function(response) {
        self.ActiveKeys = response.data;
      });
    },
    getCreatedKeys() {
      var self = this;
      this.$http.get("/keys/created").then(function(response) {
        self.CreatedKeys = response.data;
      });
    },
    getBlockedKeys() {
      var self = this;
      this.$http.get("/keys/blocked").then(function(response) {
        self.BlockedKeys = response.data;
      });
    },
    getAdmins() {
      var self = this;
      this.$http.get("/team").then(function(response) {
        self.Admins = response.data;
      });
    },
    createKey() {
      var self = this;
      if (this.email === "") {
        swal("Veuillez insérer un email pour ajouter une clef ", {
          icon: "info",
          buttons: false,
          timer: 2000
        });
      } else {
        this.$http.get("/keys/create/" + this.email).then(function(response) {
          self.CreatedKeys = response.data;
          self.LastKey = response.data[response.data.length - 1];
          self.email = "";
          self.sendMail();
        });

        swal({
          text: "La clef a bien été créée",
          title: "",
          type: "success",
          buttons: false,
          timer: 2000
        });
      }
    },
    sendMail() {
      console.log(this.LastKey);
      var self = this;
      this.$http
        .post("/mail", {
          email: self.LastKey.email,
          key: self.LastKey.key
        })
        .then(function(response) {
          console.log(response.data);
        });
    },
    deleteKey(key) {
      var self = this;
      this.$http.get("/keys/delete/" + key).then(function(response) {
        self.BlockedKeys = response.data;
      });
      swal({
        title: "",
        text: "La clef a bien été supprimée",
        timer: 2000,
        type: "success"
      });
    },
    removeKey(key) {
      var self = this;
      this.$http.get("/keys/remove/" + key.key).then(function(response) {
        self.CreatedKeys = response.data;
      });
      swal({
        title: "",
        text: "La clef a bien été supprimée",
        timer: 2000,
        type: "success"
      });
    },
    revokeAccess(key) {
      var self = this;
      this.$http.get("/keys/revoke/" + key.key).then(function(response) {
        self.ActiveKeys = response.data;
        self.getBlockedKeys();
      });
      swal({
        title: "",
        text: "Vous avez bloqué l'accès à " + key.name + " !",
        type: "success",
        buttons: false,
        timer: 2000
      });
    },
    grantAccess(key) {
      var self = this;
      this.$http.get("/keys/grant/" + key.key).then(function(response) {
        self.BlockedKeys = response.data;
        self.getActivateKeys();
      });
      swal({
        title: "",
        text: "Vous avez authorisé l'accès à " + key.name + " !",
        type: "success",
        buttons: false,
        timer: 2000
      });
    },
    deleteAccess(key) {
      var self = this;
      console.log(swal.getState());
      swal({
        text: "Vous avez supprimé l'accès de " + key.name + " !",
        type: "successs",
        buttons: false,
        timer: 2000
      });
      this.$http.get("/keys/delete/" + key.key).then(function(response) {
        self.BlockedKeys = response.data;
      });
    }
  }
};
</script>
<style lang="css">

</style>
